<template>
    <div >
    <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="title"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="WorkSheet"
          :ReportName="'WorkSheetReport'"
          :ReportTitle="title"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'

    export default Vue.extend({
        name: "WorkSheetRep",
        mixins: [ ShowMessage ],
        components: { DxPopup },
        props: {
          RecordId: String,
          closeWindow: Function,
          title: String,
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
              isReportVisible: false,
              modalId: 'Admissions',
              emitCloseEvent: false,
              reportParams: [],
            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            }
          },
        },
        methods: {

            onShowing(e) {
              let contentElement = e.component.content();
              let titleElement = e.component._$title[0]
              contentElement.style.padding = '0px';
              titleElement.style.padding = '0px 20px'
            },

            onHiddenReport() {
              this.isReportVisible = false
              this.close()
            },

            close() {
              this.emitEventCancel();
            },

            initializeParameters() {
              this.reportParams = []
              this.reportParams.push({ paramName: 'RecordId', paramValue: this.RecordId})
            },

            onClickShowReport(event) {
              // Prevenir el cierre del modal
              if (event && event.preventDefault) {
                event.preventDefault();
              }

             // if (this.visible) this.onHidden();

              this.initializeParameters();
              this.isReportVisible = true
              this.$refs.WorkSheet.buildDocument(this.reportParams)
            },

            onHidden() {
              if (this.emitCloseEvent) {
                this.$emit('close');
                this.emitCloseEvent= false;
              }
            },

            emitEventCancel() {
              this.emitCloseEvent= false;
              this.$emit('close');
            },
        },

        mounted () {
           this.onClickShowReport()
        },
    })
</script>
<style>
  .dxrd-report-preview-holder {
      height: 94% !important;
  }
</style>
